export default __webpack_public_path__ + "static/media/onoff.14c34699.svg";